const env: NodeJS.ProcessEnv = (typeof process === 'object' && process && process.env) || {};
const { NODE_ENV, REACT_UI_TEST, REACT_APP_REACT_UI_TEST, STORYBOOK_REACT_UI_TEST } = env;

const isReactUITestEnv =
  Boolean(REACT_UI_TEST) || // for cases when NODE_ENV is not usable (dev/prod)
  Boolean(REACT_APP_REACT_UI_TEST) || // for usage with CRA
  Boolean(STORYBOOK_REACT_UI_TEST); // for usage with storybook

export const isTestEnv = NODE_ENV === 'test' || isReactUITestEnv;

export const isBrowser = typeof window !== 'undefined';

export function isElement(el: unknown): el is Element {
  return !!el && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
}

export const getDoc = (node: Node): Document => node.ownerDocument ?? (node as Document);
export const getWin = (node: Node): (WindowProxy & typeof globalThis) | null => getDoc(node).defaultView;
